const DOT = [{ q: 0, r: 0 }];
const CIRCLE_2 = [
  { q: 0, r: 0 },
  { q: 1, r: 0 },
  { q: 0, r: 1 },
  { q: -1, r: 1 },
  { q: -1, r: 0 },
  { q: 0, r: -1 },
  { q: 1, r: -1 }
];
const CIRCLE_3 = [
  { q: 0, r: 0 },
  { q: 1, r: 0 },
  { q: 0, r: 1 },
  { q: -1, r: 1 },
  { q: -1, r: 0 },
  { q: 0, r: -1 },
  { q: 1, r: -1 },
  { q: 2, r: 0 },
  { q: 1, r: 1 },
  { q: -1, r: 2 },
  { q: -2, r: 2 },
  { q: -2, r: 1 },
  { q: -2, r: 0 },
  { q: -1, r: -1 },
  { q: 1, r: -2 },
  { q: 2, r: -2 },
  { q: 2, r: -1 }
];
const ARC_3 = [
  { q: 0, r: 0 },
  { q: 1, r: 0 },
  { q: 0, r: 1 },
  { q: -1, r: 1 },
  { q: -1, r: 0 },
  { q: 0, r: -1 }
];
const LINE_3 = [
  { q: 0, r: 0 },
  // Origin
  { q: 1, r: 0 },
  // One hex east
  { q: 2, r: 0 }
  // Two hexes east
];
const LINE_6 = [
  { q: 0, r: 0 },
  // Origin
  { q: 1, r: 0 },
  { q: 2, r: 0 },
  { q: 3, r: 0 },
  { q: 4, r: 0 },
  { q: 5, r: 0 }
  // Six hexes east
];
const HEX = {
  DOT,
  CIRCLE_2,
  CIRCLE_3,
  ARC_3,
  LINE_3,
  LINE_6
};
export {
  HEX
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vc3JjL2FjdGlvbnMvaGV4LXBhdHRlcm5zLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJpbXBvcnQgeyBIZXhDb29yZCB9IGZyb20gJy4vdHlwZXMnO1xuXG5jb25zdCBET1Q6IEhleENvb3JkW10gPSBbeyBxOiAwLCByOiAwIH1dO1xuXG5jb25zdCBDSVJDTEVfMjogSGV4Q29vcmRbXSA9IFtcbiAgeyBxOiAwLCByOiAwIH0sXG4gIHsgcTogMSwgcjogMCB9LFxuICB7IHE6IDAsIHI6IDEgfSxcbiAgeyBxOiAtMSwgcjogMSB9LFxuICB7IHE6IC0xLCByOiAwIH0sXG4gIHsgcTogMCwgcjogLTEgfSxcbiAgeyBxOiAxLCByOiAtMSB9LFxuXTtcblxuY29uc3QgQ0lSQ0xFXzM6IEhleENvb3JkW10gPSBbXG4gIHsgcTogMCwgcjogMCB9LFxuICB7IHE6IDEsIHI6IDAgfSxcbiAgeyBxOiAwLCByOiAxIH0sXG4gIHsgcTogLTEsIHI6IDEgfSxcbiAgeyBxOiAtMSwgcjogMCB9LFxuICB7IHE6IDAsIHI6IC0xIH0sXG4gIHsgcTogMSwgcjogLTEgfSxcbiAgeyBxOiAyLCByOiAwIH0sXG4gIHsgcTogMSwgcjogMSB9LFxuICB7IHE6IC0xLCByOiAyIH0sXG4gIHsgcTogLTIsIHI6IDIgfSxcbiAgeyBxOiAtMiwgcjogMSB9LFxuICB7IHE6IC0yLCByOiAwIH0sXG4gIHsgcTogLTEsIHI6IC0xIH0sXG4gIHsgcTogMSwgcjogLTIgfSxcbiAgeyBxOiAyLCByOiAtMiB9LFxuICB7IHE6IDIsIHI6IC0xIH0sXG5dO1xuXG5jb25zdCBBUkNfMzogSGV4Q29vcmRbXSA9IFtcbiAgeyBxOiAwLCByOiAwIH0sXG4gIHsgcTogMSwgcjogMCB9LFxuICB7IHE6IDAsIHI6IDEgfSxcbiAgeyBxOiAtMSwgcjogMSB9LFxuICB7IHE6IC0xLCByOiAwIH0sXG4gIHsgcTogMCwgcjogLTEgfSxcbl07XG5cbmNvbnN0IExJTkVfMzogSGV4Q29vcmRbXSA9IFtcbiAgeyBxOiAwLCByOiAwIH0sIC8vIE9yaWdpblxuICB7IHE6IDEsIHI6IDAgfSwgLy8gT25lIGhleCBlYXN0XG4gIHsgcTogMiwgcjogMCB9LCAvLyBUd28gaGV4ZXMgZWFzdFxuXTtcblxuY29uc3QgTElORV82OiBIZXhDb29yZFtdID0gW1xuICB7IHE6IDAsIHI6IDAgfSwgLy8gT3JpZ2luXG4gIHsgcTogMSwgcjogMCB9LFxuICB7IHE6IDIsIHI6IDAgfSxcbiAgeyBxOiAzLCByOiAwIH0sXG4gIHsgcTogNCwgcjogMCB9LFxuICB7IHE6IDUsIHI6IDAgfSwgLy8gU2l4IGhleGVzIGVhc3Rcbl07XG5cbmV4cG9ydCBjb25zdCBIRVggPSB7XG4gIERPVCxcbiAgQ0lSQ0xFXzIsXG4gIENJUkNMRV8zLFxuICBBUkNfMyxcbiAgTElORV8zLFxuICBMSU5FXzYsXG59IGFzIGNvbnN0O1xuIl0sCiAgIm1hcHBpbmdzIjogIkFBRUEsTUFBTSxNQUFrQixDQUFDLEVBQUUsR0FBRyxHQUFHLEdBQUcsRUFBRSxDQUFDO0FBRXZDLE1BQU0sV0FBdUI7QUFBQSxFQUMzQixFQUFFLEdBQUcsR0FBRyxHQUFHLEVBQUU7QUFBQSxFQUNiLEVBQUUsR0FBRyxHQUFHLEdBQUcsRUFBRTtBQUFBLEVBQ2IsRUFBRSxHQUFHLEdBQUcsR0FBRyxFQUFFO0FBQUEsRUFDYixFQUFFLEdBQUcsSUFBSSxHQUFHLEVBQUU7QUFBQSxFQUNkLEVBQUUsR0FBRyxJQUFJLEdBQUcsRUFBRTtBQUFBLEVBQ2QsRUFBRSxHQUFHLEdBQUcsR0FBRyxHQUFHO0FBQUEsRUFDZCxFQUFFLEdBQUcsR0FBRyxHQUFHLEdBQUc7QUFDaEI7QUFFQSxNQUFNLFdBQXVCO0FBQUEsRUFDM0IsRUFBRSxHQUFHLEdBQUcsR0FBRyxFQUFFO0FBQUEsRUFDYixFQUFFLEdBQUcsR0FBRyxHQUFHLEVBQUU7QUFBQSxFQUNiLEVBQUUsR0FBRyxHQUFHLEdBQUcsRUFBRTtBQUFBLEVBQ2IsRUFBRSxHQUFHLElBQUksR0FBRyxFQUFFO0FBQUEsRUFDZCxFQUFFLEdBQUcsSUFBSSxHQUFHLEVBQUU7QUFBQSxFQUNkLEVBQUUsR0FBRyxHQUFHLEdBQUcsR0FBRztBQUFBLEVBQ2QsRUFBRSxHQUFHLEdBQUcsR0FBRyxHQUFHO0FBQUEsRUFDZCxFQUFFLEdBQUcsR0FBRyxHQUFHLEVBQUU7QUFBQSxFQUNiLEVBQUUsR0FBRyxHQUFHLEdBQUcsRUFBRTtBQUFBLEVBQ2IsRUFBRSxHQUFHLElBQUksR0FBRyxFQUFFO0FBQUEsRUFDZCxFQUFFLEdBQUcsSUFBSSxHQUFHLEVBQUU7QUFBQSxFQUNkLEVBQUUsR0FBRyxJQUFJLEdBQUcsRUFBRTtBQUFBLEVBQ2QsRUFBRSxHQUFHLElBQUksR0FBRyxFQUFFO0FBQUEsRUFDZCxFQUFFLEdBQUcsSUFBSSxHQUFHLEdBQUc7QUFBQSxFQUNmLEVBQUUsR0FBRyxHQUFHLEdBQUcsR0FBRztBQUFBLEVBQ2QsRUFBRSxHQUFHLEdBQUcsR0FBRyxHQUFHO0FBQUEsRUFDZCxFQUFFLEdBQUcsR0FBRyxHQUFHLEdBQUc7QUFDaEI7QUFFQSxNQUFNLFFBQW9CO0FBQUEsRUFDeEIsRUFBRSxHQUFHLEdBQUcsR0FBRyxFQUFFO0FBQUEsRUFDYixFQUFFLEdBQUcsR0FBRyxHQUFHLEVBQUU7QUFBQSxFQUNiLEVBQUUsR0FBRyxHQUFHLEdBQUcsRUFBRTtBQUFBLEVBQ2IsRUFBRSxHQUFHLElBQUksR0FBRyxFQUFFO0FBQUEsRUFDZCxFQUFFLEdBQUcsSUFBSSxHQUFHLEVBQUU7QUFBQSxFQUNkLEVBQUUsR0FBRyxHQUFHLEdBQUcsR0FBRztBQUNoQjtBQUVBLE1BQU0sU0FBcUI7QUFBQSxFQUN6QixFQUFFLEdBQUcsR0FBRyxHQUFHLEVBQUU7QUFBQTtBQUFBLEVBQ2IsRUFBRSxHQUFHLEdBQUcsR0FBRyxFQUFFO0FBQUE7QUFBQSxFQUNiLEVBQUUsR0FBRyxHQUFHLEdBQUcsRUFBRTtBQUFBO0FBQ2Y7QUFFQSxNQUFNLFNBQXFCO0FBQUEsRUFDekIsRUFBRSxHQUFHLEdBQUcsR0FBRyxFQUFFO0FBQUE7QUFBQSxFQUNiLEVBQUUsR0FBRyxHQUFHLEdBQUcsRUFBRTtBQUFBLEVBQ2IsRUFBRSxHQUFHLEdBQUcsR0FBRyxFQUFFO0FBQUEsRUFDYixFQUFFLEdBQUcsR0FBRyxHQUFHLEVBQUU7QUFBQSxFQUNiLEVBQUUsR0FBRyxHQUFHLEdBQUcsRUFBRTtBQUFBLEVBQ2IsRUFBRSxHQUFHLEdBQUcsR0FBRyxFQUFFO0FBQUE7QUFDZjtBQUVPLE1BQU0sTUFBTTtBQUFBLEVBQ2pCO0FBQUEsRUFDQTtBQUFBLEVBQ0E7QUFBQSxFQUNBO0FBQUEsRUFDQTtBQUFBLEVBQ0E7QUFDRjsiLAogICJuYW1lcyI6IFtdCn0K
